import * as angular from 'angular';

"use strict";

angular.module('LanguagesModule', [])

export default 'LanguagesModule';
